/**
 * Emails authorized to view restricted admin pages
 * (Revenue Reporting, Agent Agreements).
 */
export const ADMIN_RESTRICTED_EMAILS = [
  "ericmedinajr@merchantservicedepot.com",
  "gabriel@merchantservicedepot.com",
  "jimneeley@gmail.com",
  "seth@merchantservicedepot.com",
  "admin@msd.com",
  "dhaval@merchantservicedepot.com",
] as const;

export function canAccessRestrictedAdmin(email: string | undefined | null): boolean {
  if (!email) return false;
  return ADMIN_RESTRICTED_EMAILS.includes(email.toLowerCase() as typeof ADMIN_RESTRICTED_EMAILS[number]);
}
